import React from "react";

const About = () => {
  return (
    <div className="container py-8 px-4 mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 mb-4">About Us</h1>
      <p className="text-lg text-gray-600 mb-6">
        Welcome to our blog platform! This is a space where we share articles,
        insights, and ideas on various topics ranging from technology,
        lifestyle, programming, and more. Our aim is to foster a community of
        knowledge sharing and thoughtful discussions.
      </p>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Our Mission</h2>
      <p className="text-lg text-gray-600 mb-6">
        Our mission is to create a platform where people from all walks of life
        can come together, share their experiences, and learn from one another.
        Whether you are passionate about coding, digital marketing, or just want
        to read and share personal stories, you’ll find a place here.
      </p>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        Why We Started
      </h2>
      <p className="text-lg text-gray-600 mb-6">
        This blog started with the goal of providing a space to share knowledge
        and to help people discover new things. As technology continues to
        evolve, it’s more important than ever to keep up with trends and ideas.
        Our team is passionate about creating content that is engaging,
        educational, and informative.
      </p>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        Meet Our Team
      </h2>
      <p className="text-lg text-gray-600">
        Our team consists of passionate writers, developers, and creatives who
        strive to make each article engaging and useful. We are dedicated to
        providing quality content that you can trust. We believe in the power of
        collaboration and learning from each other.
      </p>
    </div>
  );
};

export default About;
